export default __webpack_public_path__ + "static/media/sacredheart.0811461e.jpg";